import {combineReducers} from "redux"
import {profile, profileError, profileIsLoading, userGallery} from "./ProfileReducer"


export default combineReducers({
	profile, profileError, profileIsLoading, userGallery,
})
